import script from "./terminal.vue?vue&type=script&setup=true&lang=js"
export * from "./terminal.vue?vue&type=script&setup=true&lang=js"

import "./terminal.vue?vue&type=style&index=0&id=63954309&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63954309"]])

export default __exports__